import clsx from "clsx";
import React from "react";
import { Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import styles from "./styles/ThankYouPage.module.css";

const ThankYouPage = () => {
  // const orderIdTemp = "#ABE-ME-12345678";
  // const orderId = "#ABE-ME-12345678";
  // const { addOrder } = useSelector((state) => state.orders);
  // const { allCourse } = useSelector((state) => state.course);

  const { addOrder } = useSelector((state) => state.orders);

  // console.log(addOrder.data);
  // console.log(allCourse.data);

  return (
    <div className={clsx(styles.container)}>
      <span className={clsx(styles.mainText)}>Thank You</span>
      <div className={clsx(styles.detailText)}>
        <span className={clsx(styles.notiText)}>Your Order is Confirmed!</span>
        {/* <span className={clsx(styles.infoText)}>
          Top Print Your Booking Order No.{" "}
          <span style={{ color: "#fe807e" }}>{orderId}</span> (Invoice) -{" "}
          <Link style={{ color: "red" }} to="/sign-in">
            Click Here
          </Link>
        </span> */}
        <div className={clsx(styles.buttonContainer)}>
          <Link to="/my-learning">
            <Button className={clsx(styles.buttonLink)}>
              Go To My Learning
            </Button>
          </Link>
          <Link to="/my-purchased-courses">
            <Button className={clsx(styles.buttonLink)}>
              Go To My Purchases
            </Button>
          </Link>
          {addOrder.data && addOrder.data.id ? (
            <Link to={`/invoice/${addOrder.data.id}`}>
              <Button className={clsx(styles.buttonLink)}>Invoice</Button>
            </Link>
          ) : null}
        </div>
      </div>
    </div>
  );
};

/* required: display name */
ThankYouPage.displayName = "ThankYouPage";

/* required: props types */
ThankYouPage.propTypes = {};

/* required: default props */
ThankYouPage.defaultProps = {};

export { ThankYouPage };
